<template>
  <div class="container-fluid p-0">
     <div class="w-100 header" v-if = 'containersToday.length != 0'>
        <p class="text-center pt-1 pb-1 m-0">Hoy</p>
     </div>
      <ul class="list-group list-group-hover list-group-striped">
        <containerSelection 
          v-for="container in orderedContainersToday"
          v-bind:key="container.name"
          v-bind:name="container.name"
          v-bind:state="container.state"
          v-bind:shipOwner="container.shipOwner"
          v-bind:expedienteId="container.expedienteId"
        ></containerSelection>
      </ul>
      <div class="w-100 header" v-if = 'containersLastweek.length != 0'>
        <p class="text-center pt-1 pb-1 m-0">Esta semana</p>
     </div>
      <containerSelection 
          v-for="container in orderedContainersLastweek" 
          v-bind:key="container.name"
          v-bind:name="container.name"
          v-bind:state="container.state"
          v-bind:shipOwner="container.shipOwner"
          v-bind:expedienteId="container.expedienteId"
       ></containerSelection>
      <div class="w-100 header" v-if = 'containersOlders.length != 0'>
        <p class="text-center pt-1 pb-1 m-0">Antiguos</p>
     </div>
      <containerSelection 
          v-for="container in orderedContainersOld"
          v-bind:key="container.name"
          v-bind:name="container.name"
          v-bind:state="container.state"
          v-bind:shipOwner="container.shipOwner"
          v-bind:expedienteId="container.expedienteId"
       ></containerSelection>
       
  </div>
</template>

<script>
import { getData } from '@/services/api'
import { getExpedientStatus, statusName, defaultActions } from '@/services/helper'
import { mapGetters } from 'vuex'
import containerSelection from '@/components/containerSelection.vue'
import _ from 'lodash'


export default {
  name: 'containersList',
  components: {
    containerSelection
  },

  data() {
    return {
      containers: [
        // {
        //   name: 'RESERVA',
        //   state: 'documentación de expediente',
        //   shipOwner: null,
        //   lastUpdate: '29-07-2020',
        // },
        // {
        //   name: 'CONT-555-6854FG',
        //   state: 'En recogida',
        //   shipOwner: 'Maersk',
        //   lastUpdate: '29-07-2020',
        // },
        // {
        //   name: 'CONT-666-6854FG',
        //   state: 'En recogida',
        //   shipOwner: 'Maersk',
        //   lastUpdate: '27-07-2020',
        // },
        // {
        //   name: 'CONT-999-6854FG',
        //   state: 'En recogida',
        //   shipOwner: 'Maersk',
        //   lastUpdate: '28-07-2020',
        // }
      ],
      containersToday:[],
      containersLastweek:[],
      containersOlders:[],

    }
  },
  computed: { 
    /*...mapGetters("user",{
      authorized: 'authorized',
    }),
    */
    ...mapGetters(["view_role"]),
    orderedContainersToday: function () {
      return _.orderBy(this.containersToday, 'lastUpdate','asc')
    },
    orderedContainersLastweek: function () {
      return _.orderBy(this.containersLastweek, 'lastUpdate','asc')
    },
    orderedContainersOld: function () {
      return _.orderBy(this.containersOlders, 'lastUpdate','asc')
    },
  },
  mounted () {
    this.$store.dispatch('container/resetDefaultActions',defaultActions())
      .then(resp => { console.log('Container reseteado en vuex') })
      .catch(err => {console.log(err) })
    this.getExpedients()
    this.$store.dispatch('change_container_view_selected_tab', {tab: 'actions'});
    //this.getContainers()
    //if(this.view_role == 'Cargador' || this.view_role == 'Transitario' || this.view_role == 'Naviera' )
    //    this.getExpedients()
  },
  methods: {
    getExpedients: function () {
      var currentDay =  new Date()
      var Today =  new Date(currentDay.setDate(currentDay.getDate() - 1));
      var lastWeek =  new Date(currentDay.setDate(currentDay.getDate() - 7));

  
      getData('expedientes/').then(res => {
        var expedientes = res.data
        this.containers = []
        expedientes.forEach(expediente => {
          getData('expedientes/' + expediente.internalId + '/actions/').then(result => {
            var nameToDisplay = ''
            var isCoantainer = false
            var shipOwner = null
            if(expediente.contenedores[0] && expediente.contenedores[0].matricula_id){
              //nameToDisplay = expediente.contenedores[0].matricula_id
              nameToDisplay = expediente.internalId
              isCoantainer = true
              if(expediente.naviera) shipOwner = expediente.naviera.name
            }
            else {
              nameToDisplay = expediente.internalId
            }
            var status = getExpedientStatus(result.data)

            var shipOwnerName
            if(expediente.naviera){
              shipOwnerName = expediente.naviera.name
            }
            else {
              shipOwnerName = null
            }
            var currentExpedient = { 
              name: nameToDisplay,
              state: statusName(status.state),
              shipOwner: shipOwnerName,
              lastUpdate: status.last_update,
              expedienteId: expediente.internalId
            }
            // console.log(new Date(status.last_update))
            // console.log(Today)
            // console.log(new Date(Today) <= new Date(status.lastUpdate))
            
            if(isCoantainer == true || (this.view_role == 'Cargador' || this.view_role == 'Transitario' || this.view_role == 'Naviera' )){
              if(Today <= currentExpedient.lastUpdate){
                this.containersToday.push(currentExpedient)
              }else if(lastWeek <= currentExpedient.lastUpdate){
                this.containersLastweek.push(currentExpedient)
              }else{
                this.containersOlders.push(currentExpedient)
              }
            }
          });             
        });      
      });
    },
    /*getExpedients: function () {
      getData('expedientes/').then(res => {
        var expedientes = res.data
        this.containers = []
        expedientes.forEach(expediente => {
          // if(!expediente.naviera)
          //     expediente.naviera = '--------'
          this.containers.push({ 
            name: expediente.internalId,
            state: expediente.state,
            shipOwner: expediente.naviera,
            lastUpdate: null
          })
        });
        this.orderContainers()
      })
    },*/
    getContainers: function () {
      getData('containers/').then(res => {
        this.containers = this.containers.concat(res.data)
        //this.orderContainers()
      })
    },
    /*orderContainers: function () {
      this.containersToday = []
      this.containersLastweek = []
      this.containersOlders = []

      var currentDay =  new Date()
      var Today =  new Date(currentDay.setDate(currentDay.getDate() - 1));
      var lastWeek =  new Date(currentDay.setDate(currentDay.getDate() - 7));
      this.containers.forEach(container => {
        if(container.lastUpdate){
          var Arraydate = container.lastUpdate.split('-');
          var last_date = new Date(parseInt(Arraydate[2]),parseInt(Arraydate[1]-1),parseInt(Arraydate[0]));
         // var last_date = new Date(parseInt(Arraydate[0]),parseInt(Arraydate[1]-1),parseInt(Arraydate[2]));
          if(Today <= last_date){
            this.containersToday.push(container)
          }else if(lastWeek <= last_date){
            this.containersLastweek.push(container)
          }else{
            this.containersOlders.push(container)
          }
        }else {
          this.containersOlders.push(container)
        }
      });
    }*/
    orderContainers: function (currentContainer) {
      var currentDay =  new Date()
      var Today =  new Date(currentDay.setDate(currentDay.getDate() - 1));
      var lastWeek =  new Date(currentDay.setDate(currentDay.getDate() - 7));
      this.containers.forEach(container => {
        if(container.lastUpdate){
          var Arraydate = container.lastUpdate.split('-');
          var last_date = new Date(parseInt(Arraydate[2]),parseInt(Arraydate[1]-1),parseInt(Arraydate[0]));
         // var last_date = new Date(parseInt(Arraydate[0]),parseInt(Arraydate[1]-1),parseInt(Arraydate[2]));
          if(Today <= last_date){
            this.containersToday.push(container)
          }else if(lastWeek <= last_date){
            this.containersLastweek.push(container)
          }else{
            this.containersOlders.push(container)
          }
        }else {
          this.containersOlders.push(container)
        }
      });
    }

  }
}
</script>

<style lang= "scss" scoped>

.container-fluid {
  overflow: auto; 
  height: calc(100% - 160px);
}

.header {
  background-color: $grey1;
}

ul.list-group.list-group-striped li:nth-of-type(odd){
  background: #f8f8f8;
}

ul.list-group.list-group-striped li:nth-of-type(even){
  background: #ffffff;
}


</style>
